module.exports = __webpack_public_path__ + "img/d03c7a8.png";